import React, {Component} from 'react';
import {Card} from 'react-bootstrap';
import SignInForm from './Forms/SignIn/SignInForm';
import '../../../assets/sass/pages/auth/sign-in.scss';

class SignIn extends Component {
    render() {
        const {loading, signIn, errors} = this.props;

        return (
            <Card className="sign-in">
                <h1 className="text-center">Sign In</h1>
                <SignInForm/>
            </Card>
        )
    }
}


export default (SignIn);
